<template>
  <div class="container">
    <contact-bar></contact-bar>
    <navigation-bar></navigation-bar>
    <div class="block pt-6">
      <h1
        class="has-text-centered has-text-primary"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        ALFA PACK, HACEMOS LA DIFERENCIA
      </h1>
      <div class="colums is-mobile">
        <div class="columnis-10 is-offset-1">
          <p
            class="has-text-centered has-text-primary is-size-5 p-5"
            style="font-family: Calibri"
          >
            Nosotros brindamos asesoramiento especializado y tecnología de
            vanguardia en maquinaria para mejorar la eficiencia, calidad y
            seguridad de su empresa, maximizando su rentabilidad.
          </p>
        </div>
      </div>
    </div>
  </div>
  <figure class="image is-16by9">
    <video
      autoplay
      loop
      muted
      class="has-ratio"
      frameborder="0"
      width="100%"
      height="auto"
    >
      <source src="/video_inicio_alfapack.mp4" type="video/mp4" />
    </video>
  </figure>
  <div class="container pb-6">
    <div class="block pt-6">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <h1
            class="has-text-centered has-text-primary"
            :class="width < 768 ? 'is-size-3' : 'is-size-1'"
            style="font-family: Calibri; font-weight: bold"
          >
            ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE
          </h1>
        </div>
      </div>
      <div class="colums is-mobile">
        <div class="column is-10 is-offset-1">
          <p
            class="has-text-centered has-text-primary has-text-weight-bold"
            style="font-family: Calibri"
          >
            En el momento que lo necesites,
            <span class="has-text-yellow">contáctanos.</span>
          </p>
        </div>
      </div>
      <div class="block pt-5">
        <div class="columns is-variable" :class="width < 768 ? '' : 'is-7'">
          <div class="column">
            <p class="has-text-centered pt-4">
              <svg-icon
                class="p-5"
                type="mdi"
                :path="mdiCog"
                style="
                  color: white;
                  background-color: #38ac61;
                  width: 7.5rem;
                  height: 7.5rem;
                  border-radius: 50%;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-primary has-text-centered pt-2"
              style="font-family: Calibri; font-weight: bold"
            >
              Integramos maquinaria en diversas líneas de producción.
            </p>
          </div>
          <div class="column">
            <p class="has-text-centered pt-4">
              <svg-icon
                class="p-5"
                type="mdi"
                :path="mdiHandExtended"
                style="
                  color: white;
                  background-color: #38ac61;
                  width: 7.5rem;
                  height: 7.5rem;
                  border-radius: 50%;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-primary has-text-centered pt-2"
              style="font-family: Calibri; font-weight: bold"
            >
              Realizamos servicios de mantenimiento o reparación.
            </p>
          </div>
          <div class="column">
            <p class="has-text-centered pt-4">
              <svg-icon
                class="p-5"
                type="mdi"
                :path="mdiWrench"
                style="
                  color: white;
                  background-color: #38ac61;
                  width: 7.5rem;
                  height: 7.5rem;
                  border-radius: 50%;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-primary has-text-centered pt-2"
              style="font-family: Calibri; font-weight: bold"
            >
              Ofrecemos refacciones para mantener tus equipos en óptimas
              condiciones.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <representadas-component :has-title="true"></representadas-component>
  <difference-component></difference-component>
  <div class="container">
    <equipos-carrusel
      clasification="todos"
      title="TE INVITAMOS A CONOCER NUESTROS EQUIPOS"
      text="Ofrecemos una amplia gama de equipos para múltiples industrias: alimentos, bebidas, farmacéutica y más, cubriendo necesidades de envase, empaque y embalaje."
    ></equipos-carrusel>
  </div>
  <section class="hero has-background-blue pt-6 pb-6">
    <div class="hero-body">
      <div class="container">
        <h1
          class="has-text-centered has-text-white"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          PONTE EN CONTACTO CON NOSOTROS
        </h1>
        <div class="columns is-centered is-mobile">
          <div class="column is-two-thirds">
            <p
              class="has-text-white has-text-centered is-size-6 pt-4 pb-6"
              style="font-family: Calibri; font-weight: bold"
            >
              Valoramos la durabilidad en las relaciones. Creemos en la
              confianza, la lealtad y el compromiso como pilares clave. Nuestra
              filosofía se refleja en cada proyecto, marcando la diferencia en
              el mercado y más allá.
            </p>
          </div>
        </div>
        <div class="is-mobile level">
          <div class="level-item">
            <button
              class="button is-hoverable has-background-yellow has-text-white is-normal"
              style="
                font-family: Calibri;
                font-weight: bold;
                border: none;
                width: 15rem;
                height: 3rem;
              "
            >
              CONTACTA A UN ASESOR
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer-component></footer-component>
</template>

<script setup lang="ts">
import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import EquiposCarrusel from "@/components/EquiposCarrusel.vue";
import DifferenceComponent from "@/components/DifferenceComponent.vue";
import { mdiCog, mdiHandExtended, mdiWrench } from "@mdi/js";
import { useWindowSize } from "vue-window-size";
import RepresentadasComponent from "@/components/RepresentadasComponent.vue";
import { ref } from "vue";

const { width } = useWindowSize();

const videoInicio = ref({ src: require("@/assets/video_inicio_alfapack.mp4") });
</script>
